export const ProjectId = state => state.ProjectId
export const titleName = state => state.titleName
export const editName = state => state.editName
export const portraitPic = state => state.portraitPic
export const keepAlive = state => state.keepAlive





// WEBPACK FOOTER //
// ./src/store/getters.js